import { render, staticRenderFns } from "./ModuleTable.vue?vue&type=template&id=ec904edc&"
import script from "./ModuleTable.vue?vue&type=script&lang=js&"
export * from "./ModuleTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports